import configModule from '../../../../temp/config.js';

const config = configModule.default || configModule;

export const LATLONG_URL = config.LATLONG_URL;

export const API = {
  submit_details: {
    generate_otp: '/api/RVSF/CreateRVSFOTP',
    verify_otp: '/api/RVSF/VerifyRVSFOTP',
    submit_form: '/api/RVSF/SubmitRVSF',
  },
};
